import { UserActivity } from '@/store/modules/jig/types'

interface JigWithUserActivity {
  Id?: string
  UserActivity?: UserActivity
}

/**
 * Production adapter for the local MUE service-lock harness. Vite replaces
 * imports of this module with the harness while serving locally or building for
 * verified staging. Other deployed lock and metadata flows remain unchanged.
 */
export function getJigSpaceServiceLockMock(_jigId?: string, _existingActivity?: UserActivity): UserActivity | null {
  return null
}

export function applyJigSpaceServiceLockMock<T extends JigWithUserActivity>(jig: T): T {
  return jig
}
